var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RegistryDataTable',{attrs:{"loading":_vm.loading,"registries":_vm.registries,"total":_vm.total},on:{"update":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }